var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Box, Typography } from '@mui/material';
import React, { forwardRef } from 'react';
import { gray35 } from '../../colors/gray';
import { resolveSvgIcon } from '../../utils/internalUtils';
import { rem } from '../../utils/rem';
// Styles.
var styles = {
    root: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        padding: 4,
        textAlign: 'center',
    },
};
// Components.
var Empty = forwardRef(function (_a, ref) {
    var icon = _a.icon, title = _a.title, description = _a.description, action = _a.action, _b = _a.hasIconColor, hasIconColor = _b === void 0 ? true : _b, iconColor = _a.iconColor, _c = _a.sx, sx = _c === void 0 ? [] : _c, props = __rest(_a, ["icon", "title", "description", "action", "hasIconColor", "iconColor", "sx"]);
    var iconsStyles = {
        htmlColor: hasIconColor ? iconColor || gray35 : undefined,
        height: rem(42),
        width: rem(42),
    };
    return (React.createElement(Box, __assign({ sx: __spreadArray([styles.root], (Array.isArray(sx) ? sx : [sx]), true) }, props, { ref: ref }),
        icon &&
            resolveSvgIcon(icon, iconsStyles, {
                style: __assign({ color: iconsStyles.htmlColor }, iconsStyles),
            }),
        typeof title === 'string' ? (React.createElement(Typography, { color: "text.secondary", variant: "h2" }, title)) : (title),
        description && (React.createElement(Typography, { color: "text.secondary", variant: "subtitle2" }, description)),
        action));
});
Empty.displayName = 'Empty';
export default Empty;
